import React from 'react';

import cn from 'libs/cn';

const FullscreenMessageWrapper = ({
  className,
  ...rest
}: React.HTMLAttributes<HTMLElement>) => (
  <section
    className={cn(
      'flex h-2/3 flex-col items-center justify-center gap-4 px-8 py-12 text-center',
      className
    )}
    {...rest}
  />
);

export default FullscreenMessageWrapper;
